import { Component } from '@angular/core';
import { MatMenuTrigger } from '@angular/material';

import { AuthService } from './shared/auth.service';
import { IUserCredentials } from './shared/shared.interface';
import { Intercom } from 'ng-intercom';

/* Пока тестовый вариант с прелоадером. Отлавливать событие activate на outlet и скрывать прелоадер.
Загрузка первого компонента отключает прелоадер и включает свой. */
@Component({
  selector: 'app-root',
  template: `<app-toolbar></app-toolbar>
  <router-outlet (activate)="app_loading_state = false;">
  <div class="preloader" *ngIf="app_loading_state"><div class="pageloader-icon"></div></div>
  </router-outlet>`
})
export class AppComponent { 
  app_loading_state: boolean = true;

  constructor (
    public intercom: Intercom, 
    private auth: AuthService
  ) {
    //Проверяем есть ли текущий пользователь, если есть, то инициализируем интерком и начинаем трэкать
    let currentUser = this.auth.get_current_user();
    if (currentUser.access_token) {
      this.intercom.boot({app_id: 'v0nmz32q', name: currentUser.fullname, 
      email: currentUser.email, user_hash: currentUser.iwd});
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts